<script setup>
import { ref, onUpdated, defineProps, defineEmits, computed } from "vue"
import useUsers from "../../use/useUsers"

const props = defineProps({
  userWallet: {
    required: true,
    type: Object,
  },
})

const walletData = ref({
  user_id: props.userWallet.userId,
  balance: props.userWallet.walletBalance,
  amount: "",
  actionType: "",
})

const formattedPrices = computed(() => {
  if (walletData.value.balance >= 0) {
    return new Intl.NumberFormat("fa-IR").format(walletData.value.balance)
  } else {
    return 0
  }
})

const emit = defineEmits(["update:modelValue", "close"])

const { show, loading, errors, updateUserWallet, closeModal } = useUsers(
  props,
  emit,
  null,
  walletData
)

onUpdated(() => {
  walletData.value = {
    user_id: props.userWallet.userId,
    balance: props.userWallet.walletBalance,
    amount: "",
    actionType: "",
  }
})
</script>

<template>
  <!-- edit user wallet modal  -->
  <b-modal
    v-model="show"
    @close="closeModal()"
    id="showModal"
    hide-footer
    title=" کیف پول کاربر"
    header-class="p-3 bg-light"
    class="v-modal-custom"
    centered
    no-close-on-backdrop
  >
    <b-overlay
      variant="white"
      opacity="0.75"
      blur="2px"
      :show="loading"
      spinner-variant="success"
      rounded="sm"
    >
      <b-card>
        <b-form
          id="addform"
          class="tablelist-form"
          autocomplete="off"
          @submit.prevent="updateUserWallet"
        >
          <input type="hidden" v-model="walletData.user_id" />
          <div class="mb-3">
            <label for="walletbalance" class="form-label"
              >موجودی کیف پول کاربر</label
            >
            <input
              type="text"
              id="walletbalance"
              class="form-control"
              :value="formattedPrices"
              disabled
            />
          </div>

          <div class="mb-3">
            <label for="actiontype" class="form-label">نوع عملیات</label>
            <select
              class="form-control"
              data-trigger
              id="actiontype"
              v-model="walletData.actionType"
            >
              <option value="" selected>انتخاب نوع عملیات</option>
              <option value="decrease">کم کردن از کیف پول</option>
              <option value="increase">افزودن به کیف پول</option>
            </select>
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.actionType">
                <span>{{ errors.actionType[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="phone" class="form-label">مبلغ</label>
            <input
              type="tel"
              id="phone"
              class="form-control"
              placeholder="مبلغ موردنظر را وارد کنید"
              v-model="walletData.amount"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.amount">
                <span>{{ errors.amount[0] }}</span>
              </div>
            </div>
          </div>

          <div class="hstack gap-2 justify-content-end">
            <b-button
              type="button"
              id="closemodal"
              variant="light"
              @click="closeModal"
            >
              بستن
            </b-button>
            <b-button type="submit" variant="success">ذخیره</b-button>
          </div>
        </b-form>
      </b-card>
    </b-overlay>
    <div class="modal-footer v-modal-footer">
      <div class="mx-auto" v-if="walletData.user_id">
        <RouterLink
          :to="{
            name: 'users.wallet.transactions',
            params: { userId: walletData.user_id },
          }"
          class="btn btn-link fw-medium shadow-none"
        >
          جزئیات بیشتر
          <i class="ri-arrow-left-line ms-1 align-middle"></i>
        </RouterLink>
      </div>
    </div>
  </b-modal>
</template>
